// extracted by mini-css-extract-plugin
export default {"chart":"MainChart_chart__IFeWq"};